"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferTypeEnum = void 0;
exports.TransferTypeEnum = {
    Conference: "conference",
    SipRefer: "sip_refer",
};
